/* eslint-disable react/jsx-key */
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import { BoxWrapper } from 'components/Base';
import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Router from 'components/Router/Router';
import { LanguageOutlined, Star } from '@material-ui/icons';
import api from 'api';
import { useHistory } from 'react-router-dom';
import { makeStyles, CircularProgress } from '@material-ui/core';
import EditOutlined from '@material-ui/icons/EditOutlined';
import Main from './Content/Main';
import Portfolios from './Content/Portfolios';
import Sidebar from './Sidebar/Sidebar';
import ROUTES from 'consts/routes';
import { connect } from 'react-redux';
import { compose } from 'redux-starter-kit';
import actions from 'store/actions';
import { secondaryText } from 'utils/colors';

const { useParams } = Router;

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    left: 0
  },
  disclaimer: {
    whiteSpace: 'pre-wrap',
    color: secondaryText
  }
});

const MpsHubProviderPage = ({ updateBenchmarks }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const { provider } = useParams() as any;
  const [selectedProvider, setSelectedProvider] = useState({} as any);
  const [isLoading, setIsLoading] = useState(true);
  const [isFavourite, setIsFavourite] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [favouriteProviderId, setFavouriteProviderId] = useState(undefined);
  const [legalRelationships, setLegalRelationships] = useState(undefined);

  useEffect(() => {
    setIsLoading(true);
    api.getMpsProviders().then(({ data }) => {
      const matchedProvider = data.results.filter((item: any) => {
        return item.slug === provider;
      });
      if (matchedProvider.length === 0) {
        history.push(ROUTES.MPS_HUB.BASE);
        return;
      }
      api.getMpsProviderAdmins().then(({ data }) => {
        setIsAdmin(
          data.results.find(
            (item: any) => item.provider.id === matchedProvider[0].id
          )
        );
      });
      api.getMpsProvider(matchedProvider[0].id).then(({ data }) => {
        setSelectedProvider(data);
        localStorage.setItem('providerName', data.name);
        api.getBenchmarks().then(response => {
          updateBenchmarks(response);
          api.getLegalRelationships().then(({ data }: any) => {
            setLegalRelationships(data);
            setIsLoading(false);
          });
        });
      });
      api.getMpsProvidersFavourites().then(({ data }) => {
        const favouriteProvider = data.results.find(
          (item: any) => item.provider.id === matchedProvider[0].id
        );
        setFavouriteProviderId(favouriteProvider ? favouriteProvider.id : null);
        setIsFavourite(!!favouriteProvider);
      });
    });

    // eslint-disable-next-line
  }, []);

  const markAsFavourite = (provider: any) => {
    if (isFavourite) {
      return api
        .removeMpsProvidersFavourite(provider, favouriteProviderId)
        .then(() => {
          api.getMpsProvidersFavourites().then(() => {
            setFavouriteProviderId(undefined);
            setIsFavourite(false);
          });
        });
    }
    api.setMpsProvidersFavourite(provider).then(() => {
      api.getMpsProvidersFavourites().then(({ data }) => {
        const favouriteProvider = data.results.find(
          (item: any) => item.provider.id === provider.id
        );
        setFavouriteProviderId(favouriteProvider.id);
        setIsFavourite(true);
      });
    });
  };

  return (
    <Dashboard>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress size="80px" />
        </div>
      ) : (
        <Grid
          container
          spacing={2}
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        >
          <Grid item xs={12} md={12} lg={8}>
            <BoxWrapper>
              <div
                style={{
                  padding: '3rem',
                  paddingBottom: '1rem',
                  paddingTop: '2rem',
                  position: 'sticky',
                  top: '0',
                  zIndex: '1000',
                  background: 'inherit',
                  borderRadius: '25px 25px 0 0',
                  borderBottom: '1px solid #d4d4d4'
                }}
              >
                <>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '2rem',
                      flexWrap: 'wrap'
                    }}
                  >
                    <img
                      src={selectedProvider.logo_url}
                      alt={selectedProvider.name}
                      style={{
                        width: '200px',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                    />
                    <div
                      style={{
                        fontSize: '1.5rem',
                        fontWeight: '700'
                      }}
                    >
                      {selectedProvider.name}
                    </div>
                    {selectedProvider.claimed && (
                      <div
                        style={{
                          display: 'flex',
                          gap: '.5rem',
                          marginLeft: 'auto'
                        }}
                      >
                        <Star
                          onClick={() => {
                            markAsFavourite(selectedProvider);
                          }}
                          style={{
                            fill: isFavourite ? '#ea8f08' : '#FFFFFF',
                            stroke: isFavourite ? '#ea8f08' : '#000000',
                            fontSize: '28',
                            cursor: 'pointer',
                            strokeWidth: '2'
                          }}
                        />
                        {selectedProvider.website && (
                          <a
                            href={selectedProvider.website}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <LanguageOutlined
                              style={{ fontSize: '28', fill: '#000000' }}
                            />
                          </a>
                        )}
                        {isAdmin ? (
                          <div
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              history.push(
                                ROUTES.MPS_HUB.PROVIDER_EDIT.replace(
                                  ':provider',
                                  provider
                                )
                              )
                            }
                          >
                            <EditOutlined
                              style={{ fontSize: '28', fill: '#000000' }}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                </>
              </div>

              <Main provider={selectedProvider} />
            </BoxWrapper>

            {selectedProvider.portfolio_ranges.length > 0 && (
              <BoxWrapper
                title="Portfolios"
                style={{ marginTop: '2rem', marginBottom: '1rem' }}
              >
                <Portfolios provider={selectedProvider} />
              </BoxWrapper>
            )}
            <Box display={{ xs: 'none', lg: 'block' }}>
              <div className={classes.disclaimer}>
                {selectedProvider.computed_disclaimer}
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            <Sidebar
              provider={selectedProvider}
              legalRelationships={legalRelationships}
            />
          </Grid>
          <Box display={{ xs: 'block', lg: 'none' }}>
            <div className={classes.disclaimer}>
              {selectedProvider.computed_disclaimer}
            </div>
          </Box>
        </Grid>
      )}
    </Dashboard>
  );
};

export default compose(
  connect(null, {
    updateBenchmarks: actions.metaActions.updateBenchmarks
  })
)(MpsHubProviderPage);
